import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SrIcon } from "@/components/ui/SrIcon";
import { MEDIA_KIND_LABELS } from "@/lib/equipment/enrichment";
import type { ProductMediaFile } from "@/hooks/use-equipment-products";
import type { DBEquipmentProduct } from "@/lib/db-types";

/**
 * Manual, datablad og spesifikasjoner for modellen (VIB-2918). Hører til
 * modellen, så alle enheter av samme modell viser det samme.
 */
export function ProductDocumentsCard({ product, media }: { product: DBEquipmentProduct | null; media: ProductMediaFile[] }) {
  const documents = media.filter((m) => m.kind !== "image");
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Dokumenter</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {documents.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            {product ? "Ingen manual eller datablad lagret for modellen." : "Ingen modell valgt. Bruk «Hent produktdata» for å koble utstyret til en modell."}
          </p>
        ) : (
          <ul className="divide-y">
            {documents.map((doc) => (
              <li key={doc.id} className="flex items-center justify-between gap-3 py-2 text-sm">
                <a href={doc.url} target="_blank" rel="noreferrer" className="flex min-w-0 items-center gap-2 hover:underline">
                  <SrIcon name="file-text" className="h-4 w-4 shrink-0 text-muted-foreground" />
                  <span className="truncate">{doc.title || MEDIA_KIND_LABELS[doc.kind]}</span>
                </a>
                <span className="shrink-0 rounded-full bg-primary/10 px-2 py-0.5 text-[11.5px] font-semibold text-primary">
                  {MEDIA_KIND_LABELS[doc.kind]} · {doc.source === "manufacturer" ? "Produsent" : "Nett"}
                </span>
              </li>
            ))}
          </ul>
        )}
        {product && product.specs.length > 0 && (
          <details>
            <summary className="cursor-pointer text-sm font-medium">Spesifikasjoner ({product.specs.length})</summary>
            <dl className="mt-2 grid grid-cols-[2fr_3fr] gap-x-3 gap-y-1 text-sm">
              {product.specs.map((s) => (
                <div key={s.label} className="contents">
                  <dt className="text-muted-foreground">{s.label}</dt>
                  <dd>{s.value}</dd>
                </div>
              ))}
            </dl>
          </details>
        )}
      </CardContent>
    </Card>
  );
}
